import { useState } from "react";
import Slider from "react-slick";

const MunCommittees = ({ committees = [] }) => {
  const [selectedCommittee, setSelectedCommittee] = useState(null);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="mun-committees-wrap">
      <Slider {...settings} className="mun-committees">
        {committees.map((committee, index) => (
          <div className="mun-committee-slide" key={committee.CommitteesName || index}>
            <div className="mun-committee-card">
              {committee.image ? (
                <div className="mun-committee-image">
                  <img src={committee.image} alt={committee.CommitteesName} className="img-fluid" />
                </div>
              ) : null}
              <h3>{committee.CommitteesName}</h3>
              <p className="mun-role">
                <strong>{committee.ChairLabel || "Chair"}-</strong> {committee.Chair}
              </p>
              <p className="mun-role">
                <strong>{committee.DeputyLabel || "Deputy"}-</strong> {committee.Deputy || ""}
              </p>
              <p>{committee.message}</p>
              {committee.quote ? <p className="mun-role">{committee.quote}</p> : null}
              {committee.agenda ? (
                <p className="mun-agenda-line">
                  <strong>AGENDA-</strong> {committee.agenda}
                </p>
              ) : null}
              <button
                type="button"
                className="mun-read-more-btn"
                onClick={() => setSelectedCommittee(committee)}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </Slider>

      {selectedCommittee ? (
        <div
          className="mun_ncs-block mun-popup-backdrop"
          onClick={() => setSelectedCommittee(null)}
        >
          <div
            className="mun-popup-card"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="mun-popup-close"
              onClick={() => setSelectedCommittee(null)}
            >
              ×
            </button>
            {selectedCommittee.image ? (
              <div className="mun-committee-image">
                <img src={selectedCommittee.image} alt={selectedCommittee.CommitteesName} className="img-fluid" />
              </div>
            ) : null}
            <h3>{selectedCommittee.CommitteesName}</h3>
            <p className="mun-role">
              <strong>{selectedCommittee.ChairLabel || "Chair"}-</strong> {selectedCommittee.Chair}
            </p>
            <p className="mun-role">
              <strong>{selectedCommittee.DeputyLabel || "Deputy"}-</strong> {selectedCommittee.Deputy || ""}
            </p>
            <p>{selectedCommittee.message}</p>
            {selectedCommittee.quote ? <p className="mun-role">{selectedCommittee.quote}</p> : null}
            {selectedCommittee.agenda ? (
              <p className="mun-agenda-line">
                <strong>AGENDA-</strong> {selectedCommittee.agenda}
              </p>
            ) : null}
            {selectedCommittee.agendaText ? <p>{selectedCommittee.agendaText}</p> : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MunCommittees;
